/**
 * React Query key factory for the notification subsystem.
 *
 * <p>Centralised so cache invalidation never has to guess the key shape:
 * the realtime SSE hook can call {@code invalidate(notificationKeys.all)}
 * to refresh every list, count, and preference query in one go.</p>
 */
export const notificationKeys = {
  all: ['notifications'] as const,
  lists: () => [...notificationKeys.all, 'list'] as const,
  list: (unreadOnly: boolean) => [...notificationKeys.lists(), { unreadOnly }] as const,
  unreadCount: () => [...notificationKeys.all, 'unread-count'] as const,
  preferences: () => [...notificationKeys.all, 'preferences'] as const,
};
